import React from 'react';
import { Responsive, SimpleList, Filter, List, Edit, Create, Datagrid, SimpleForm, TextInput,
NumberInput, SelectInput,TextField, EditButton, required, SelectArrayInput,
BooleanInput, LongTextInput, SimpleShowLayout, Show, ArrayField, SingleFieldList, ChipField } from 'react-admin';
import { Field } from 'redux-form'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormLabel from '@material-ui/core/FormLabel';

import { resources_by_name } from './pkadmin/resources.js'
//import { TextField as MUTextField } from 'redux-form-material-ui'
import PostEditActions from './pkadmin/CreateEditActions'
import subjects from './subjects.json'
import MyParentComponentWrapper from "./MyParentComponentWrapper";
import { ArrayToStringField } from './pkadmin/components/ArrayToStringField'

const ProfilesFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <TextInput source="id"/>
<TextInput source="name"/>
<TextInput source="qs_to_answer"/>
<TextInput source="questionsets_id"/>
    </Filter>
);

const ProfilesListTitle = ({ record }) => {
    return <span>Profiles</span>;
};

export const ProfilesList = (props) => (
    <div>
    <Card>
        <CardContent>
          <p>Here is a list of your profiles. Yes, you can create multiple profiles! The most common reason for doing this would be if you are able to work in 2 separate locations e.g. Dublin or Cork.</p>
        </CardContent>
    </Card>
    <br />
    <List title={<ProfilesListTitle />} {...props} filters={<ProfilesFilter />}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.id}
                    secondaryText={record => record.profilename}
                    tertiaryText={record => record.firstnames +", "+record.familynames}
                />
            }
            medium={
                <Datagrid>
                     <TextField source="id" />
                     <TextField source="profilename" label="Profile Name"/>
                     <TextField source="firstnames" label="First Name"/>
                     <TextField source="familynames" label="Family Name"/>
                     <ArrayToStringField source="subjects" label="Subjects"/>

                    <EditButton />
                </Datagrid>
            }
        />
    </List>
    </div>
);


const ProfilesCreateEditTitle = ({ record }) => {
    return <span>Teacher Profile {record ? `"${record.firstnames}"` : ''}</span>;
};

export const ProfilesEdit = (props) => (
      <Edit title={<ProfilesCreateEditTitle />} actions={<PostEditActions refresh={true}/>} {...props}>
          <SimpleForm defaultValue={{lat: 53.3423, lng: -6.25}}>
            <TextInput
              className="md-cell md-cell--top"
              helperText="Give this profile a name - useful if you create more than one."
              label="Profile Name"
              name="profilename"
              source="profilename"
              {...resources_by_name['profiles']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="First Names"
              name="firstnames"
              validate={required('Required')}
              source="firstnames"
              {...resources_by_name['profiles']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Family Names"
              name="familynames"
              validate={required('Required')}
              source="familynames"
              {...resources_by_name['profiles']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Contact Email"
              name="email"
              validate={required('Required')}
              source="email"
              type="email"
              {...resources_by_name['profiles']['field_args']}/>
            <TextInput
              label="Contact Phone Number"
              name="phonenumber"
              validate={required('Required')}
              source="phonenumber"
              {...resources_by_name['profiles']['field_args']}/>
            <SelectArrayInput
              helperText="Select all the subjects that you are able and willing to teach"
              label="Subjects"
              source="subjects"
              choices={subjects} />
            <SelectInput label="Highest Education Achieved" source="highesteducationachieved" validate={required('Required')}
            choices={[
                { id: 'secondaryschool', name: 'Secondary School/High School' },
                { id: 'otherthirdlevel', name: "Other Post-Leaving Cert/Third Level Course" },
                { id: 'highercertificate', name: "Higher/Advanced Certificate" },
                { id: 'ordinarybachelor', name: "Ordinary Bachelor's Degree" },
                { id: 'bachelor', name: "Honours Bachelor's Degree" },
                { id: 'masters', name: "Master's Degree" },
                { id: 'phd', name: "PhD Degree" }
            ]} />
            <LongTextInput
              label="Education Details (Optional)"
              name="education"
              source="education"
              {...resources_by_name['profiles']['field_args']}/>
            <LongTextInput
              label="Work Experience Details (Optional)"
              name="workexperience"
              source="workexperience"
              {...resources_by_name['profiles']['field_args']}/>

            <br />
            <FormLabel component="legend">Select Your Location on the map below</FormLabel>
            <MyParentComponentWrapper />
            <Field name="lat" component="input" type="hidden" step="0.01" />
            <Field name="lng" component="input" type="hidden" step="0.01" />

            <NumberInput
              helperText="Set the distance you're willing to travel from location specified (leave empty for no restriction)"
              label="Travel Distance"
              source="traveldistance"
              {...resources_by_name['profiles']['field_args']}/>
            <BooleanInput
              label="Select if you will travel with no restrictions if accomodation available"
              source="willtakeaccomodation"
            />
          </SimpleForm>
      </Edit>
);


export const ProfilesCreate = (props) => (
    <Create title={<ProfilesCreateEditTitle />}  {...props}>

        <SimpleForm defaultValue={{lat: 53.3423, lng: -6.25}} redirect="list">
          <TextInput
            className="md-cell md-cell--top"
            helperText="Give this profile a name - useful if you create more than one."
            label="Profile Name"
            name="profilename"
            source="profilename"
            {...resources_by_name['profiles']['field_args']}/>
          <TextInput
            className="md-cell md-cell--top"
            label="First Names"
            name="firstnames"
            validate={required('Required')}
            source="firstnames"
            {...resources_by_name['profiles']['field_args']}/>
          <TextInput
            className="md-cell md-cell--top"
            label="Family Names"
            name="familynames"
            validate={required('Required')}
            source="familynames"
            {...resources_by_name['profiles']['field_args']}/>
          <TextInput
            className="md-cell md-cell--top"
            label="Contact Email"
            name="email"
            validate={required('Required')}
            source="email"
            type="email"
            {...resources_by_name['profiles']['field_args']}/>
          <TextInput
            label="Contact Phone Number"
            name="phonenumber"
            validate={required('Required')}
            source="phonenumber"
            {...resources_by_name['profiles']['field_args']}/>
          <SelectArrayInput
            helperText="Select all the subjects that you are able and willing to teach"
            label="Subjects"
            source="subjects"
            choices={subjects} />
          <SelectInput label="Highest Education Achieved" source="highesteducationachieved" validate={required('Required')}
          choices={[
              { id: 'secondaryschool', name: 'Secondary School/High School' },
              { id: 'otherthirdlevel', name: "Other Post-Leaving Cert/Third Level Course" },
              { id: 'highercertificate', name: "Higher/Advanced Certificate" },
              { id: 'ordinarybachelor', name: "Ordinary Bachelor's Degree" },
              { id: 'bachelor', name: "Honours Bachelor's Degree" },
              { id: 'masters', name: "Master's Degree" },
              { id: 'phd', name: "PhD Degree" }
          ]} />
          <LongTextInput
            label="Education Details (Optional)"
            name="education"
            source="education"
            {...resources_by_name['profiles']['field_args']}/>
          <LongTextInput
            label="Work Experience Details (Optional)"
            name="workexperience"
            source="workexperience"
            {...resources_by_name['profiles']['field_args']}/>

          <br />
          <FormLabel component="legend">Select Your Location on the map below</FormLabel>
          <MyParentComponentWrapper />
          <Field name="lat" component="input" type="hidden" step="0.01" />
          <Field name="lng" component="input" type="hidden" step="0.01" />

          <NumberInput
            helperText="Set the distance you're willing to travel from location specified (leave empty for no restriction)"
            label="Travel Distance"
            source="traveldistance"
            {...resources_by_name['profiles']['field_args']}/>
          <BooleanInput
            label="Select if you will travel with no restrictions if accomodation available"
            source="willtakeaccomodation"
          />
        </SimpleForm>
    </Create>
);


export const ProfilesShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
          <TextField
            className="md-cell md-cell--top"
            helperText="Give this profile a name - useful if you create more than one."
            label="Profile Name"
            name="profilename"
            source="profilename"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            className="md-cell md-cell--top"
            label="First Names"
            name="firstnames"
            validate={required('Required')}
            source="firstnames"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            className="md-cell md-cell--top"
            label="Family Names"
            name="familynames"
            validate={required('Required')}
            source="familynames"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            className="md-cell md-cell--top"
            label="Contact Email"
            name="email"
            validate={required('Required')}
            source="email"
            type="email"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            label="Contact Phone Number"
            name="phonenumber"
            validate={required('Required')}
            source="phonenumber"
            {...resources_by_name['profiles']['field_args']}/>
          <ArrayField source="subjects" label="Subjects">
              <SingleFieldList>
                  <ChipField source="name" />
              </SingleFieldList>
          </ArrayField>
          <SelectInput label="Highest Education Achieved" source="highesteducationachieved" validate={required('Required')}
            choices={[
                { id: 'secondaryschool', name: 'Secondary School/High School' },
                { id: 'otherthirdlevel', name: "Other Post-Leaving Cert/Third Level Course" },
                { id: 'highercertificate', name: "Higher/Advanced Certificate" },
                { id: 'ordinarybachelor', name: "Ordinary Bachelor's Degree" },
                { id: 'bachelor', name: "Honours Bachelor's Degree" },
                { id: 'masters', name: "Master's Degree" },
                { id: 'phd', name: "PhD Degree" }
            ]} />
          <LongTextInput
            label="Education Details (Optional)"
            name="education"
            source="education"
            {...resources_by_name['profiles']['field_args']}/>
          <LongTextInput
            label="Work Experience Details (Optional)"
            name="workexperience"
            source="workexperience"
            {...resources_by_name['profiles']['field_args']}/>

          <br />
          <FormLabel component="legend">Select Your Location on the map below</FormLabel>
          <MyParentComponentWrapper />
          <Field name="lat" component="input" type="hidden" step="0.01" />
          <Field name="lng" component="input" type="hidden" step="0.01" />

          <NumberInput
            helperText="Set the distance you're willing to travel from location specified (leave empty for no restriction)"
            label="Travel Distance"
            source="traveldistance"
            {...resources_by_name['profiles']['field_args']}/>
          <BooleanInput
            label="Select if you will travel with no restrictions if accomodation available"
            source="willtakeaccomodation"
          />
        </SimpleShowLayout>
    </Show>
);
